export const invoiceColumns = [
  { label: "ID", value: "invoices.id" },
  { label: "Business ID", value: "invoices.business_id" },
  { label: "Branch ID", value: "invoices.branch_id" },
  { label: "Supplier Code", value: "invoices.supplier_code" },
  { label: "Buyer Code", value: "invoices.buyer_code" },
  //   { label: "Version", value: "invoices.version" },
  { label: "Type Code", value: "invoices.type_code" },
  { label: "Invoice Number", value: "invoices.code_number" },
  { label: "Issuance Date", value: "invoices.invoice_date" },
  { label: "Issuance Time", value: "invoices.invoice_time" },
  //   { label: "Issuer Digital Signature", value: "invoices.issuer_digital_signature" },
  //   { label: "Currency Code", value: "invoices.currency_code" },
  //   { label: "Currency Exchange Rate", value: "invoices.currency_exchange_rate" },
  //   { label: "Frequency of Billing", value: "invoices.frequency_of_billing" },
  //   { label: "Billing Period Start Date", value: "invoices.billing_period_start_date" },
  //   { label: "Billing Period End Date", value: "invoices.billing_period_end_date" },
  //   { label: "Payment Mode", value: "invoices.payment_mode" },
  //   { label: "Supplier Bank Account Number", value: "invoices.supplier_bank_account_number" },
  //   { label: "Payment Terms", value: "invoices.payment_terms" },
  //   { label: "Prepayment Amount", value: "invoices.prepayment_amount" },
  //   { label: "Prepayment Date", value: "invoices.prepayment_date" },
  //   { label: "Prepayment Time", value: "invoices.prepayment_time" },
  //   { label: "Prepayment Reference Number", value: "invoices.prepayment_reference_number" },
  //   { label: "Bill Reference Number", value: "invoices.bill_reference_number" },
  { label: "Total Excluding Tax", value: "invoices.total_excluding_tax" },
  { label: "Total Including Tax", value: "invoices.total_including_tax" },
  { label: "Total Payable Amount", value: "invoices.total_payable_amount" },
  { label: "Total Net Amount", value: "invoices.total_net_amount" },
  { label: "Total Discount Value", value: "invoices.total_discount_value" },
  {
    label: "Total Fee Charge Amount",
    value: "invoices.total_fee_charge_amount",
  },
  { label: "Total Tax Amount", value: "invoices.total_tax_amount" },
  { label: "Rounding Amount", value: "invoices.rounding_amount" },
  //   { label: "Total Taxable Amount Per Tax Type", value: "invoices.total_taxable_amount_per_tax_type" },
  {
    label: "Total Tax Amount Per Tax Type",
    value: "invoices.total_tax_amount_per_tax_type",
  },
  //   { label: "Tax Type", value: "invoices.tax_type" },
  {
    label: "Invoice Additional Discount Amount",
    value: "invoices.invoice_additional_discount_amount",
  },
  //   { label: "Invoice Additional Fee Amount", value: "invoices.invoice_additional_fee_amount" },
  //   { label: "Created At", value: "invoices.created_at" },
  //   { label: "Updated At", value: "invoices.updated_at" },
  //   { label: "Updated By", value: "invoices.updated_by" },
  //   { label: "Updated Type", value: "invoices.updated_type" },
  { label: "Deleted At", value: "invoices.deleted_at" },
  //   { label: "Deletion Reason", value: "invoices.deletion_reason" },
  { label: "POS Reference Number", value: "invoices.original_invoice_number" },
  //   { label: "Reason", value: "invoices.reason" },
  {
    label: "Original Invoice Reference",
    value: "invoices.original_invoice_reference",
  },
  { label: "Job Code", value: "invoices.job_code" },
  { label: "Invoice Date", value: "invoices.doc_date" },
  //   { label: "Is Consolidate Pickable", value: "invoices.is_consolidate_pickable" },
  { label: "Is Consolidated", value: "invoices.is_consolidated" },
  {
    label: "Is Edited Via Self Service",
    value: "invoices.is_edited_via_self_service",
  },
  //   { label: "Consolidate Group", value: "invoices.consolidate_group" },
];

export const buyerColumns = [
  {
    label: "Buyer Registration Type",
    value: "invoices.buyer_registration_type",
  },
  {
    label: "Buyer Registration Number",
    value: "invoices.buyer_registration_number",
  },
  { label: "Buyer TIN", value: "invoices.buyer_tin" },
  { label: "Buyer Name", value: "invoices.buyer_name" },
  {
    label: "Buyer SST Registration Number",
    value: "invoices.buyer_sst_registration_number",
  },
  { label: "Buyer Email", value: "invoices.buyer_email" },
  { label: "Buyer Contact", value: "invoices.buyer_contact" },
  { label: "Buyer Address Line 1", value: "invoices.buyer_address_line0" },
  { label: "Buyer Address Line 2", value: "invoices.buyer_address_line1" },
  { label: "Buyer Address Line 3", value: "invoices.buyer_address_line2" },
  { label: "Buyer City", value: "invoices.buyer_city" },
  { label: "Buyer Postcode", value: "invoices.buyer_postcode" },
  { label: "Buyer State", value: "invoices.buyer_state" },
  { label: "Buyer Country", value: "invoices.buyer_country" },
];

export const supplierColumns = [
  {
    label: "Supplier Registration Type",
    value: "invoices.supplier_registration_type",
  },
  {
    label: "Supplier Registration Number",
    value: "invoices.supplier_registration_number",
  },
  { label: "Supplier TIN", value: "invoices.supplier_tin" },
  { label: "Supplier Name", value: "invoices.supplier_name" },
  {
    label: "Supplier SST Registration Number",
    value: "invoices.supplier_sst_registration_number",
  },
  { label: "Supplier MSIC Code", value: "invoices.supplier_msic_code" },
  {
    label: "Supplier Tourism Tax Registration Number",
    value: "invoices.supplier_tourism_tax_registration_number",
  },
  {
    label: "Supplier Business Activity Description",
    value: "invoices.supplier_business_activity_description",
  },
  { label: "Supplier Email", value: "invoices.supplier_email" },
  { label: "Supplier Contact", value: "invoices.supplier_contact" },
  {
    label: "Supplier Address Line 1",
    value: "invoices.supplier_address_line0",
  },
  {
    label: "Supplier Address Line 2",
    value: "invoices.supplier_address_line1",
  },
  {
    label: "Supplier Address Line 3",
    value: "invoices.supplier_address_line2",
  },
  { label: "Supplier City", value: "invoices.supplier_city" },
  { label: "Supplier Postcode", value: "invoices.supplier_postcode" },
  { label: "Supplier State", value: "invoices.supplier_state" },
  { label: "Supplier Country", value: "invoices.supplier_country" },
];

export const eInvoiceColumns = [
  // { label: "ID", value: "e_invoices_details.id" },
  { label: "UUID", value: "e_invoices_details.uuid" },
  { label: "Submission UID", value: "e_invoices_details.submission_uid" },
  { label: "Long ID", value: "e_invoices_details.long_id" },
  { label: "Internal ID", value: "e_invoices_details.internal_id" },
  { label: "Type Name", value: "e_invoices_details.type_name" },
  { label: "Type Version Name", value: "e_invoices_details.type_version_name" },
  { label: "Issuer TIN", value: "e_invoices_details.issuer_tin" },
  { label: "Issuer Name", value: "e_invoices_details.issuer_name" },
  { label: "Receiver ID", value: "e_invoices_details.receiver_id" },
  { label: "Receiver Name", value: "e_invoices_details.receiver_name" },
  { label: "Date Time Issued", value: "e_invoices_details.date_time_issued" },
  {
    label: "Date Time Received",
    value: "e_invoices_details.date_time_received",
  },
  {
    label: "Date Time Validated",
    value: "e_invoices_details.date_time_validated",
  },
  {
    label: "E-Invoice Total Excluding Tax",
    value: "e_invoices_details.total_excluding_tax",
  },
  {
    label: "E-Invoice Total Discount",
    value: "e_invoices_details.total_discount",
  },
  {
    label: "E-Invoice Total Net Amount",
    value: "e_invoices_details.total_net_amount",
  },
  {
    label: "E-Invoice Total Payable Amount",
    value: "e_invoices_details.total_payable_amount",
  },
  { label: "Status", value: "e_invoices_details.status" },
  { label: "Cancel Date Time", value: "e_invoices_details.cancel_date_time" },
  {
    label: "Reject Request Date Time",
    value: "e_invoices_details.reject_request_date_time",
  },
  {
    label: "Cancel Reason",
    value: "e_invoices_details.document_status_reason",
  },
  {
    label: "Created By User ID",
    value: "e_invoices_details.created_by_user_id",
  },
  {
    label: "Validation Results",
    value: "e_invoices_details.validation_results",
  },
  { label: "Invoice ID", value: "e_invoices_details.invoice_id" },
  { label: "Error Content", value: "e_invoices_details.error_content" },
  { label: "Created At", value: "e_invoices_details.created_at" },
];
